import styled from 'styled-components'
import { color } from '../../../GlobalStyle'
import { breakpoints } from '../../../MediasQueries'

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1vh;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  ,
  td,
  th {
    text-align: start;
  }

  td:last-of-type {
    text-align: center;
  }
  th {
    padding: 12px;
  }
  ,
  td {
    padding: 8px 10px;
  }

  .green {
    box-sizing: border-box;
    color: ${(props) => props.theme.brand};
    background-color: rgba(56, 211, 92, 0.1) !important;
    box-shadow: inset 0 0 0 0.15rem rgba(56, 211, 92, 0.2);
    outline: 0 none;
  }
  .greenText {
    font-weight: bold;
  }
`
export const PeriodSetDiv = styled.div`
  display: flex;

  button:nth-child(1) {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  button:nth-child(3) {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  input {
    text-align: center;
    font-weight: bold;
    width: 160px;
    background: #fff;
    border: 1px solid ${color.brand};
  }
`
export const Infos = styled.div`
  display: flex;
  flex-direction: column;

  gap: 20px;
  div {
    height: 50%;
    display: flex;
    flex-direction: column;
    align-itens: center;
    justify-content: center;
    text-align: center;
    p:nth-child(1) {
      font-size: 35px;
      color: ${color.brand};
    }
    p:nth-child(2) {
      font-size: 12px;
      font-weight: normal;
    }
    p:nth-child(3) {
      font-size: 18px;
    }
  }
`
export const GridLayout = styled.div`
  display: grid;

  grid-template-columns: repeat(10, 1fr);

  gap: 20px;

  p {
    font-weight: bold;
    font-size: 19px;
    padding: 12px 6px;

    button {
      float: right;
      margin-left: auto;
    }
  }

  .item1 {
    grid-column: span 8;
  }
  .item1-1 {
    grid-column: span 2;
  }

  .item3-1 {
    grid-column: span 4;
  }
  .item2 {
    grid-column: span 3;
  }
  .item3 {
    grid-column: span 3;
  }

  @media (max-width: ${breakpoints.sm}) {
    .item1 {
      grid-column: span 10;
    }
    .item1-1 {
      grid-column: span 10;
    }

    .item3-1 {
      grid-column: span 10;
    }
    .item2 {
      grid-column: span 10;
    }

    .item3 {
      grid-column: span 10;
    }
  }
`
export const Periods = styled.div`
  display: flex;
  width: 300px;
  button:nth-child(1) {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  button:nth-child(2) {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  button:nth-child(3) {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
`
